// src/hooks/useProject.js
import { getData, postData, updateData, deleteData } from "../services/apiService";

// Get all projects
export const fetchProjects = () => getData("/all-projects");

// Get single project
export const fetchProjectById = (id) => getData(`/projects/${id}`);

// Create project (with multiple images)
export const createProject = (formData) => postData("/add-project", formData, true);

// Update project
export const editProject = (id, formData) => updateData(`/update-project/${id}`, formData, true);

// Delete single project
export const removeProject = (id) => deleteData(`/delete-project/${id}`);

// Delete all projects
export const removeAllProjects = () => deleteData("/delete-projects");
